import {axios} from ".";
import config from '../config.json';

export const getAllDatasources = async () => {
  try{
    const {
      data
    } = await axios.get(`${config.base_url_api}/datasource/`);
    return data;
  }catch(error)
  {
    throw new Error(error)
  }
};


